import { useState } from 'react'
import classNames from 'classnames'

import { EMPTY_OBJECT, EMPTY_STRING } from '../../../constants/common'
import { List as ListComponent } from '../../List'
import { EmptyListItem } from '../../ListItem'
import { MultiValuedListMoreFilter } from '../MultiValuedListMoreFilter'

import * as styles from './MultiValuedListMoreItems.module.css'

function MultiValuedListMoreItems({
  Item,
  List = ListComponent,
  activeItem,
  className = styles.MultiValuedListMoreItems,
  filter,
  isLoading,
  itemProps = EMPTY_OBJECT,
  items,
  searchPlaceholder,
  onClickItem,
  onMouseDownItem,
  ...listProps
}) {
  const [searchValue, setSearchValue] = useState(EMPTY_STRING)

  const listItems = filter
    ? items.filter(item => filter(item, searchValue))
    : items

  return (
    <List
      {...listProps}
      className={classNames(className, { [styles.withSearch]: !!filter })}
      isLoading={isLoading}
      searchElement={
        filter ? (
          <MultiValuedListMoreFilter
            disabled={isLoading}
            placeholder={searchPlaceholder}
            value={searchValue}
            onChange={setSearchValue}
          />
        ) : null
      }
    >
      {listItems.length === 0 && !isLoading ? <EmptyListItem /> : null}
      {listItems?.map((item, index) => (
        <Item
          {...itemProps}
          {...item}
          activeItem={activeItem}
          key={item.key || index}
          onClick={onClickItem}
          onMouseDown={onMouseDownItem}
        />
      ))}
    </List>
  )
}

export default MultiValuedListMoreItems
